<template>
  <div v-click-outside="onClickOutside" class="content-center">
    <div class="top">
      <div class="left">
        <div class="htd">
          <img src="@/assets/Mobile/images/home/home_htd.png" alt="">
        </div>
        <div class="htsk">
          <img src="@/assets/Mobile/images/home/home_htsk.png" alt="">
        </div>
      </div>
      <div class="right">
        <img v-if="!open" src="@/assets/Mobile/images/home/home_more.png" alt="" @click="open=true">
        <img v-else src="@/assets/Mobile/images/home/close.png" class="close" alt="" @click="open=false">
      </div>
    </div>
    <a-menu
      v-show="open"
      theme="dark"
      class="sk-mobile-menu"
      :default-selected-keys="['1']"
      :open-keys="openKeys"
      mode="inline"
      @openChange="onOpenChange"
    >
      <a-menu-item key="index" @click="linkTo('index')">首页</a-menu-item>
      <!-- <a-sub-menu key="sub1" title="解决方案">
        <a-sub-menu key="sub2" title="电商解决方案">
          <a-menu-item key="micromall" @click="linkTo('micromall')">微商城</a-menu-item>
          <a-menu-item key="retail" @click="linkTo('chainE')">连锁电商</a-menu-item>
          <a-menu-item key="community" @click="linkTo('community')">社群分销</a-menu-item>
          <a-menu-item key="B2B2C" @click="linkTo('B2B2C')">B2B2C</a-menu-item>
          <a-menu-item key="chainE" @click="linkTo('retail')">零售电商</a-menu-item>
          <a-menu-item key="cloud-purchase" @click="linkTo('cloud-purchase')">云采购</a-menu-item>
          <a-menu-item key="live-broadcast" @click="linkTo('live-broadcast')">直播电商</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub3" title="智慧收银解决方案">
          <a-menu-item key="cashier" @click="linkTo('cashier')">智能收银</a-menu-item>
          <a-menu-item key="payment" @click="linkTo('payment')">智能支付</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub4" title="会员营销解决方案">
          <a-menu-item key="member" @click="linkTo('member')">会员CRM</a-menu-item>
          <a-menu-item key="popularize" @click="linkTo('popularize')">流量推广</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub5" title="企业定制解决方案">
          <a-menu-item key="brandCustom" @click="linkTo('brandCustom')">品牌商城定制</a-menu-item>
          <a-menu-item key="distributeCustom" @click="linkTo('distributeCustom')">分销商城定制</a-menu-item>
          <a-menu-item key="shopCustom" @click="linkTo('shopCustom')">门店管理定制</a-menu-item>
          <a-menu-item key="O2OCustom" @click="linkTo('O2OCustom')">O2O定制</a-menu-item>
        </a-sub-menu>
      </a-sub-menu>
      <a-sub-menu key="sub6" title="产业服务">
        <a-menu-item key="finance" @click="linkTo('finance')">金融服务</a-menu-item>
        <a-menu-item key="supplychain" @click="linkTo('supplychain')">供应链服务</a-menu-item>
        <a-menu-item key="agent-operation" @click="linkTo('agent-operation')">代运营服务</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="cooperate" @click="linkTo('cooperate')">渠道合作</a-menu-item>
      <a-menu-item key="eco-partner" @click="linkTo('eco-partner')">生态伙伴</a-menu-item>
      <a-sub-menu key="sub7" title="关于我们">
        <a-menu-item key="aboutUs" @click="linkTo('introduce')">企业简介</a-menu-item>
        <a-menu-item key="dynamic" @click="linkTo('dynamic')">企业动态</a-menu-item>
      </a-sub-menu> -->
      <a-sub-menu key="sub1" title="产品及服务">
        <a-sub-menu key="sub2" title="千橙零售云">
          <a-menu-item key="QcErpSystem" @click="linkTo('QcErpSystem')">千橙ERP系统</a-menu-item>
          <a-menu-item key="QcCashier" @click="linkTo('QcCashier')">千橙收银系统</a-menu-item>
          <a-menu-item key="QcChain" @click="linkTo('QcChain')">千橙连锁系统</a-menu-item>
          <a-menu-item key="QcShopkeeper" @click="linkTo('QcShopkeeper')">千橙新零售系统</a-menu-item>
          <a-menu-item key="QcShoppingMall" @click="linkTo('QcShoppingMall')">千橙微商城系统</a-menu-item>
          <a-menu-item key="QcAssociation" @click="linkTo('QcAssociation')">汇团团社群营销系统</a-menu-item>
          <a-menu-item key="QcMarketing" @click="linkTo('QcMarketing')">千橙会员营销系统</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub3" title="千橙云">
          <a-menu-item key="QcCommerce" @click="linkTo('QcCommerce')">干橙电商S2B2C系统</a-menu-item>
          <a-menu-item key="QcB2BChannel" @click="linkTo('QcB2BChannel')">千橙B2b分销系统</a-menu-item>
          <a-menu-item key="QcLiveBroadcast" @click="linkTo('QcLiveBroadcast')">汇好看直播电商</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub4" title="千橙分销云">
          <a-menu-item key="QcDistribution" @click="linkTo('QcDistribution')">千橙分销</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub5" title="千橙服务云">
          <a-menu-item key="QcTool" @click="linkTo('QcTool')">千橙RPA工具箱</a-menu-item>
          <a-menu-item key="QcDigit" @click="linkTo('QcDigit')">千橙数字人</a-menu-item>
        </a-sub-menu>
      </a-sub-menu>
      <a-menu-item key="cooperate" @click="linkTo('cooperate')">渠道合作</a-menu-item>
      <a-menu-item key="eco-partner" @click="linkTo('eco-partner')">生态伙伴</a-menu-item>
      <a-sub-menu key="sub7" title="关于我们">
        <a-menu-item key="aboutUs" @click="linkTo('introduce')">企业简介</a-menu-item>
        <a-menu-item key="dynamic" @click="linkTo('dynamic')">企业动态</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="QcDownload" @click="linkTo('QcDownload')">产品下载体验</a-menu-item>
    </a-menu>
    <a v-if="showRight" class="free" href="tel:15380446859" />
    <img v-if="showRight" class="conact" src="@/assets/Mobile/images/home/register.png" alt="" @click="toRegister()">
    <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="B2B2C" @cancel="modalClose" />
  </div>
</template>

<script>
import TryModal from '@/Mobile/Mobilecom/TryModal'
import { browseCount } from '@/apis/index'
import vClickOutside from 'v-click-outside'
export default {
  components: {
    TryModal,
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      isRefister:false,
      rootSubmenuKeys: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6', 'sub7'],
      openKeys: [],
      selectedKeys: [],
      open: false,
      tryVisible: false,
      showRight: true
    }
  },
  watch: {
    '$route'(to, from) {
      if (['/m/introduce', '/m/dynamic'].indexOf(to.path) !== -1) {
        this.showRight = false
      }
    },
    open(val, oldval) {
      document.getElementsByTagName('body')[0].style.overflow = val ? 'hidden' : 'unset'
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    linkTo(path) {
      this.$router.push({ path: '/m/' + path })
      this.$nextTick(() => {
        this.open = false
      })
      browseCount()
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        if (latestOpenKey === 'sub2' || latestOpenKey === 'sub3' || latestOpenKey === 'sub4' || latestOpenKey === 'sub5') {
          this.openKeys = ['sub1', latestOpenKey]
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : []
        }
      }
    },
    openModal: function() {
      this.tryVisible = true
    },
    modalClose: function(data) {
      this.tryVisible = data
    },
    toRegister: function() {
        this.$router.push('/registerLogin')
    },
    onClickOutside: function(event) {
      this.open = false
    }
  }
}
</script>

<style lang="less" scoped>
  .content-center {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #101010;
    z-index: 99;
    .top {
      display: flex;
      width: 100%;
      height: 50px;
      padding: 0 13px;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        .htd {
          padding-right: 13px;
          border-right: 1px solid #fff;
          img {
            width: 73px;
          }
        }
        .htsk {
          padding-left: 13px;
          img {
            width: 80px;
          }
        }
      }
      .right {
        .close {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .sk-mobile-menu {
    width: 100%;
    position: fixed;
    top: 50px;
    text-align: left;
    max-height: calc(100% - 50px);
    overflow: auto;
    z-index: 99;
  }
  .free {
    position: fixed;
    display: inline-block;
    margin: 0;
    bottom: 60px;
    right: 0;
    width: 72px;
    height: 72px;
    z-index: 60;
    background: url("~@/assets/Mobile/images/home/conact.png") no-repeat center;
    background-size: 100%;
  }
  .conact {
    position: fixed;
    bottom: 150px;
    right: 0;
    width: 72px;
    height: 72px;
    z-index: 60;
  }
  /deep/ .ant-menu.ant-menu-dark .ant-menu-item-selected {
    background-color: unset;
    font-size: 14px;
    font-weight: 400;
    color: #3684FF;
  }
</style>
